import type { Media } from "@zivin-labs/site-content";
import { DIRECTOR, DIRECTOR_PREVIEW } from "./directorMessage";

/**
 * The Chairman, Principal and Director messages — one shared source for the
 * home page's rotating panel (DirectorMessage.tsx) and the About page's
 * "Leader's Message" section. Same portrait, same pull quote, same
 * paragraphs in both places: edit here, not per-page.
 *
 * Tab order is Chairman, Principal, Director — the Principal leads by
 * choice, kept from the home page's original ordering.
 */
export interface LeadershipSlide {
  id: string;
  kicker: string;
  name: string;
  role: string;
  photo: Media;
  photoLabel: string;
  quote: string;
  body: string[];
  /**
   * Set where the letter runs longer than the panel prints. The panel shows
   * `body`, and "Read the full message" opens these in a dialog.
   */
  full?: string[];
}

export const LEADERSHIP_MESSAGES: LeadershipSlide[] = [
  {
    id: "chairman",
    kicker: "Chairman's message",
    name: "Sri. S.S. Mallikarjun",
    role: "Chairman",
    photo: { url: "sites/biet/leadership/chairman-ss-mallikarjun.jpg", alt: "Sri S.S. Mallikarjuna, Chairman", width: 450, height: 600 },
    photoLabel: "PORTRAIT · SRI. S.S. MALLIKARJUN",
    quote:
      "We measure our success by the engineers we send into the world.",
    body: [
      "Since the Bapuji Educational Association was founded in 1958, our guiding belief has been simple: that quality education is the surest path to opportunity, and that it must remain within reach of every deserving student. BIET carries that conviction forward — pairing academic rigor with the values, discipline and sense of service that define a complete engineer.",
      "To our students, faculty and partners — thank you for building this institution with us. The years ahead will ask more of all of us, and I have no doubt BIET will rise to meet them.",
    ],
  },
  {
    id: "principal",
    kicker: "Principal's message",
    name: "Dr. H.B. Aravind",
    role: "Principal · since 2019",
    photo: { url: "sites/biet/leadership/l07.jpg", alt: "Dr. H.B. Aravind, Principal", width: 1991, height: 2560 },
    photoLabel: "PORTRAIT · DR. H.B. ARAVIND",
    quote:
      "We teach so that our students become their own teachers.",
    body: [
      "Our vision is to be a centre of excellence recognised internationally, and we pursue it through outcome-based education — teaching that sends graduates into their chosen field with leadership, ethical values and a positive approach. BIET belongs to the Bapuji Educational Association, which has served education for more than sixty years and now spans some forty institutions.",
      "The 63-acre green campus holds state-of-the-art departmental laboratories, a library of international standards with e-library and lecture-capture facilities, an active placement cell, modern research infrastructure, hostels, sports grounds and a cultural auditorium. On behalf of a BIET family of around four thousand, I welcome you to join us.",
    ],
  },
  {
    id: "director",
    kicker: "Director's message",
    name: DIRECTOR.name,
    role: DIRECTOR.role,
    photo: DIRECTOR.photo,
    photoLabel: DIRECTOR.photoLabel,
    quote: DIRECTOR.headline,
    body: DIRECTOR_PREVIEW,
    full: DIRECTOR.paragraphs,
  },
];
